(() => {
  'use strict';

  if (window.__TSM_CART_DEPENDENCY_FIX_V7__) return;
  window.__TSM_CART_DEPENDENCY_FIX_V7__ = true;

  const config = window.TSM_CART_DEPENDENCIES || {};
  const BASE_ID = Number(config.baseProductId || 0);
  const ADDON_ID = Number(config.addonProductId || 0);
  const GIFT_ID = Number(config.giftProductId || 0);

  const BASE_HANDLE = config.baseHandle || 'the-shift-method-magyar';
  const ADDON_HANDLE = config.addonHandle || '24-oras-gyorsitott';
  const GIFT_HANDLE = config.giftHandle || 'vezetett-manifesztacios-naplo';

  const rootUrl =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${rootUrl}cart`;
  const checkoutUrl = '/checkout';
  const drawerSections = ['cart-drawer', 'cart-icon-bubble'];

  let busy = false;
  let checkoutStarted = false;
  let activeController = null;

  const normalizedPath = (value) => String(value || '').replace(/\/+$/, '');
  const isCartPage = () =>
    normalizedPath(window.location.pathname) ===
    normalizedPath(new URL(cartUrl, window.location.origin).pathname);

  const itemHandle = (item) => {
    if (item && typeof item.handle === 'string' && item.handle) return item.handle;
    if (item && typeof item.product_handle === 'string' && item.product_handle) {
      return item.product_handle;
    }

    const url = item && typeof item.url === 'string' ? item.url : '';
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const matchesItem = (item, id, handle) => {
    const productId = Number(item && item.product_id ? item.product_id : 0);
    if (id > 0 && productId === id) return true;
    return itemHandle(item) === handle;
  };

  const isBaseItem = (item) => matchesItem(item, BASE_ID, BASE_HANDLE);
  const isAddonItem = (item) => matchesItem(item, ADDON_ID, ADDON_HANDLE);
  const isGiftItem = (item) => matchesItem(item, GIFT_ID, GIFT_HANDLE);

  const abortActiveRequest = () => {
    if (activeController) {
      activeController.abort();
      activeController = null;
    }
  };

  const fetchWithTimeout = async (url, options = {}, timeout = 8000) => {
    abortActiveRequest();
    const controller = new AbortController();
    activeController = controller;
    const timer = window.setTimeout(() => controller.abort(), timeout);

    try {
      return await fetch(url, { ...options, signal: controller.signal });
    } finally {
      window.clearTimeout(timer);
      if (activeController === controller) activeController = null;
    }
  };

  const fetchCart = async () => {
    const response = await fetchWithTimeout(`${rootUrl}cart.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('A kosár állapota nem tölthető be.');
    return response.json();
  };

  const updateCart = async (updates) => {
    const response = await fetchWithTimeout(`${rootUrl}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates,
        sections: drawerSections,
        sections_url: cartUrl
      })
    });

    if (!response.ok) {
      let message = 'A kapcsolódó kosártételek nem távolíthatók el.';
      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch (error) {}
      throw new Error(message);
    }

    return response.json();
  };

  const setTriggerLoading = (trigger, loading) => {
    if (!trigger || !trigger.isConnected) return;
    trigger.toggleAttribute('aria-disabled', loading);
    const button = trigger.matches('button') ? trigger : trigger.querySelector('button');
    if (button) button.disabled = loading;
  };

  const parseSection = (html) => {
    if (typeof html !== 'string' || !html.trim()) return null;
    return new DOMParser().parseFromString(html, 'text/html');
  };

  const updateCartIconInPlace = (sections, cartState = null) => {
    const html = sections && sections['cart-icon-bubble'];
    const parsed = parseSection(html);
    const live = document.querySelector('#cart-icon-bubble');
    if (!parsed || !live) return;

    const sourceLink = parsed.querySelector('#cart-icon-bubble');
    const sectionWrapper = parsed.querySelector('#shopify-section-cart-icon-bubble');
    const sourceHtml = sourceLink
      ? sourceLink.innerHTML
      : sectionWrapper
        ? sectionWrapper.innerHTML
        : parsed.body.innerHTML;

    live.innerHTML = sourceHtml;

    if (sourceLink) {
      ['aria-label', 'title', 'data-cart-count'].forEach((name) => {
        if (sourceLink.hasAttribute(name)) live.setAttribute(name, sourceLink.getAttribute(name));
        else live.removeAttribute(name);
      });
    }

    if (cartState && Number(cartState.item_count || 0) === 0) {
      live.querySelectorAll('.cart-count-bubble').forEach((bubble) => bubble.remove());
    }
  };

  const renderDrawerInPlace = (cartState, trigger) => {
    const liveDrawer = document.querySelector('cart-drawer');
    const liveInner = liveDrawer && liveDrawer.querySelector('#CartDrawer .drawer__inner');
    const html = cartState && cartState.sections && cartState.sections['cart-drawer'];
    const parsed = parseSection(html);
    const sourceDrawer = parsed && parsed.querySelector('cart-drawer');
    const sourceInner = parsed && parsed.querySelector('#CartDrawer .drawer__inner');

    if (!liveDrawer || !liveInner || !sourceDrawer || !sourceInner) {
      throw new Error('A friss cart drawer tartalma nem található.');
    }

    const wasOpen = liveDrawer.classList.contains('active');
    liveInner.innerHTML = sourceInner.innerHTML;
    liveDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));

    if (typeof liveDrawer.getUpsellHandles === 'function') {
      liveDrawer.upsellHandles = liveDrawer.getUpsellHandles();
    }

    updateCartIconInPlace(cartState.sections || {}, cartState);

    const countdown = liveDrawer.querySelector('countdown-timer');
    if (countdown && typeof countdown.playTimer === 'function') countdown.playTimer();

    window.requestAnimationFrame(() => {
      if (checkoutStarted) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      if (wasOpen) {
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
        return;
      }

      if (typeof drawer.open === 'function') {
        const safeTrigger =
          (trigger && trigger.isConnected && trigger) ||
          document.querySelector('#cart-icon-bubble') ||
          null;
        drawer.open(safeTrigger);
      }
    });
  };

  const buildUpdates = (cart, clickedIndex = 0) => {
    const updates = {};

    cart.items.forEach((item, index) => {
      const isClickedLine = clickedIndex > 0 && index + 1 === clickedIndex;
      const shouldRemove =
        isBaseItem(item) || isAddonItem(item) || isGiftItem(item) || isClickedLine;

      if (shouldRemove && item.key) updates[item.key] = 0;
    });

    return updates;
  };

  const enforceBaseRemoval = async ({ clickedIndex = 0, trigger = null } = {}) => {
    if (busy || checkoutStarted) return;

    busy = true;
    setTriggerLoading(trigger, true);

    try {
      const cart = await fetchCart();
      if (checkoutStarted) return;

      const updates = buildUpdates(cart, clickedIndex);
      if (Object.keys(updates).length === 0) return;

      const updatedCart = await updateCart(updates);
      if (checkoutStarted) return;

      if (isCartPage()) {
        window.location.reload();
      } else {
        renderDrawerInPlace(updatedCart, trigger);
      }
    } catch (error) {
      if (error && error.name !== 'AbortError') {
        console.error('[The Shift Method] Cart dependency error:', error);
      }
    } finally {
      setTriggerLoading(trigger, false);
      busy = false;
    }
  };

  const baseRowFromTarget = (target) =>
    target && target.closest
      ? target.closest(`.cart-item--product-${BASE_HANDLE}`)
      : null;

  const termsAccepted = () => {
    const checkbox = document.querySelector('tnc-chekcbox');
    return !checkbox || checkbox.dataset.checked === 'true';
  };

  const startCheckout = (event, button) => {
    if (checkoutStarted || !button || button.disabled) return;
    if (!termsAccepted()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    checkoutStarted = true;
    abortActiveRequest();

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const label = button.querySelector('.button__label');
    if (label) label.textContent = 'BETÖLTÉS…';

    // Nincs köztes AJAX-kérés vagy theme callback: a böngésző azonnal a
    // Shopify saját, locale-aware checkout útvonalára lép.
    window.location.assign(checkoutUrl);
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const checkoutButton = target.closest('#CartDrawer-Checkout, #checkout');
      if (checkoutButton) {
        startCheckout(event, checkoutButton);
        return;
      }

      const removeButton = target.closest('cart-remove-button');
      if (removeButton && baseRowFromTarget(removeButton)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const row = baseRowFromTarget(removeButton);
        const clickedIndex = Number(removeButton.dataset.index || row.dataset.index || 0);
        enforceBaseRemoval({ clickedIndex, trigger: removeButton });
        return;
      }

      const minusButton = target.closest('button[name="minus"]');
      const row = minusButton ? baseRowFromTarget(minusButton) : null;
      if (!minusButton || !row) return;

      const quantityInput = row.querySelector('input.quantity__input');
      if (Number(quantityInput && quantityInput.value ? quantityInput.value : 0) > 1) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const clickedIndex = Number(
        (quantityInput && quantityInput.dataset.index) || row.dataset.index || 0
      );
      enforceBaseRemoval({ clickedIndex, trigger: minusButton });
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter;
      const isCheckoutForm =
        form.id === 'CartDrawer-Form' || form.id === 'cart' || form.action.includes('/cart');
      const isCheckoutSubmit =
        submitter && (submitter.id === 'CartDrawer-Checkout' || submitter.name === 'checkout');

      if (isCheckoutForm && isCheckoutSubmit) startCheckout(event, submitter);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const input = target ? target.closest('input.quantity__input') : null;
      const row = input ? baseRowFromTarget(input) : null;
      if (!input || !row || Number(input.value) > 0) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      enforceBaseRemoval({
        clickedIndex: Number(input.dataset.index || row.dataset.index || 0),
        trigger: input
      });
    },
    true
  );

  window.addEventListener('pageshow', () => {
    checkoutStarted = false;
    abortActiveRequest();
  });
})();
